var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('v-row',{},[_c('v-col',{attrs:{"cols":"12"}},[_c('DataTableComponent',{attrs:{"table":_vm.tableData}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }